"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var t=(e=>(e.OpenAppointmentCard="open-appointment-card",e))(t||{});exports.DataTestIds=t;
